<template>
	<!-- <div class="cb-field" :class="{'cb-field--sibling':siblingError}"> -->
  <!-- Selecting based on index is too dangerous. TODO change it while refactoring -->
    <select-field :siblingError="siblingError" @informError="$emit('informError')" :name="subFields[1].name" @clearError="$emit('clearError')" v-if="showSelect" :useparent='true' :options="stateList">
    </select-field>
    <text-field  :siblingError="siblingError" @informError="$emit('informError')" @clearError="$emit('clearError')" :name="subFields[0].name" :useparent='true' v-else>
    </text-field>
	<!-- </div> -->
</template>
<script type="text/javascript">
import TextField from "./TextField"
import SelectField from "./SelectField"
import StateCodeList from "@/utils/state-code-list"
import StateListHelper from "@/utils/state-list-helper"
import { AddressENUM } from '@/utils/address-validator';

export default {
  props: ['name', 'siblingError'],
  components: {
    'text-field': TextField,
    'select-field': SelectField
  },
  watch: {
    showSelect(newValue, oldValue) {
      if(newValue) {
        this.clearState();
      }
      else{
        this.clearStateCode();
      }
    },
    countryValue(newValue, oldValue) {
      if(newValue && oldValue) {
        if([newValue, oldValue].every(v => ['US', 'CA', 'IN','AE'].indexOf(v) > -1)) {
          this.clearStateCode();
        }
      }
    },
    stateFieldValue(newValue, oldValue) {
      if (newValue) {
        if (StateListHelper.canShowStateDropdown(this.$store,this.countryValue)) {
          this.clearState();
        }
      }
    }
  },
  data() {
    return {
      // showSelect: false;
      pName: "",
      customClass: "",
      temporaryState: []
    }
  },
  created() {
    this.pName = this.findParentForm();
    const configAddress = this.$store.getters.addresses;
      if(this.pName==AddressENUM.BILLING_ADDRESS_FIELD){
        this.temporaryState = configAddress.filter(address => address?.address_type==AddressENUM.BILLING_ADDRESS);
      }else if(this.pName==AddressENUM.SHIPPING_ADDRESS_FIELD){
        this.temporaryState = configAddress.filter(address => address?.address_type==AddressENUM.SHIPPING_ADDRESS);
      }else if(this.pName==AddressENUM.CARD_FIELD){
        this.temporaryState = configAddress.filter(address => address?.address_type==AddressENUM.CARD);
      }
  },
  mounted() {
    this.customClass = this.$vnode.data.staticClass;
  },
  computed: {
    config() {
      return this.$store.getters.vField_config(this.pName, this.name)
    },
    countryValue() {
      return this.cName && this.$store.getters.field_value(this.pName, this.cName);
    },
    stateFieldValue() {
      return this.cName && this.$store.getters.field_value(this.pName, this.subFields[0].name);
    },
    showSelect() {
      return StateListHelper.canShowStateDropdown(this.$store,this.countryValue);
    },
    cName() {
      return this.config && JSON.parse(this.config.meta.extra).country_name;
    },
    subFields() {
      return this.config.meta.sub_fields;
    },
    stateList() {
     const state = this.temporaryState && this.temporaryState[0]?.countries?.find((list) => list.country_code == this.countryValue);

     const allowedState = state?.allowed_regions?.state_code;
     const blockedState = state?.blocked_regions?.state_code;

      return this.showSelect && Object.entries(StateCodeList[this.countryValue])
      .filter(([stateName, stateCode]) => {
        if (allowedState) {
          // If allowedState exists, only include those states in allowedState
          return allowedState.includes(stateCode);
        } else if (blockedState) {
          // If blockedState exists, exclude those states in blockedState
          return !blockedState.includes(stateCode);
        }
        // If neither allowedState nor blockedState exists, include all states
        return true;
      })
      .map(([stateName, stateCode]) => ({
        "display_name": stateName,
        "value": stateCode
      }));
    }
  },
  methods: {
    clearState() {
      this.$store.dispatch('update_form_input', {
        name: this.subFields[0].name,
        value: "",
        formName: this.pName
      });
    },
    clearStateCode() {
      if (! this.doesStateCodeBelongToCountry()) {
        this.$store.dispatch('update_form_input', {
          name: this.subFields[1].name,
          value: "",
          formName: this.pName
        });
      }
    },
    doesStateCodeBelongToCountry() {
      const stateCode = this.$store.getters.field_value(this.pName, 'state_code')
      return !!stateCode && !!this.stateList.find(state => state.value === stateCode)
    }
  }
}
</script>
